
import React from "react";
import "./buttonHL.css";
const ButtonHLPure = (props) => {
  const {
    nameBtn, //Text in btn
    primary, //Btn true to primary colors
    onClickBtn, //Function onClick button
    disabled, //True to disabled button, false not disabled
  } = props;

  return (
    <button
      {...props}
      type="button"
      className={
        primary === true ? "buttonHLPure-primary" : "buttonHLPure-secondary"
      }
      onClick={onClickBtn}
      disabled={disabled}
    >
      {nameBtn}
    </button>
  );
};

export { ButtonHLPure as default };